import { Box, Divider, Tab, Tabs } from "@material-ui/core"
import React from "react"
import { Redirect, Route, Switch, useHistory, useParams } from "react-router-dom"
import { AreaHeader, Content, DesktopCreateTrainingButton } from "../../components"
import { useQueryTrainingModules } from "../../data"
import { useAuth } from "../../services"
import { Assessment } from "./Assessment"
import { Courses } from "./Courses"
import { Modules } from "./Modules"

const TrainingRoutes = () => (
  <Switch>
    <Route path="/training/modules/:id" component={Modules} />
    <Route path="/training/modules" component={Modules} />
    <Route path="/training/courses/:id" component={Courses} />
    <Route path="/training/courses" component={Courses} />
    <Route path="/training/assessment" component={Assessment} />
    <Redirect to="/training/modules" />
  </Switch>
)

const Index = () => {
  const history = useHistory()
  const { data, loading } = useQueryTrainingModules()
  const { tab } = useParams()
  const { hasFeature } = useAuth()

  const handleCreate = (type) => {
    history.push(`/training/${type}/new`)
  }

  const handleTabChange = (event, newTab) => history.push(`/training/${newTab}`)

  const hasTrainingAssessment = hasFeature(["training", "training_assessment"])

  if (!tab) {
    return <TrainingRoutes />
  }

  const hasModules = Boolean(data?.trainingModules.length)

  return (
    <>
      <AreaHeader
        titleIcon="training"
        title="Training"
        desktopButtons={<DesktopCreateTrainingButton onCreateClick={handleCreate} />}
      />

      <Content full start mb={tab === "assessment" ? 0 : 5}>
        <Tabs value={tab} onChange={handleTabChange}>
          <Tab label="Modules" value="modules" />
          <Tab label="Courses" value="courses" disabled={loading || !hasModules} />
          {hasTrainingAssessment && <Tab label="Assessment" value="assessment" disabled={loading || !hasModules} />}
        </Tabs>

        <Divider />

        <Box pt={2} mb={tab === "assessment" ? 0 : 5}>
          <TrainingRoutes />
        </Box>
      </Content>
    </>
  )
}

export default Index
